// extracted by mini-css-extract-plugin
export var actionText = "_ho-4";
export var container = "_ho-0";
export var leftSection = "_ho-1";
export var rightSection = "_ho-2";
export var settingsButton = "_ho-6";
export var settingsIcon = "_ho-7";
export var shortcut = "_ho-5";
export var shortcutGroup = "_ho-3";